import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { ValgInputModule } from "@valg-shared/components/input/input.module";
import { MatIconModule } from "@angular/material/icon";
import { TooltipModule } from "@valg-shared/components/tooltip/tooltip.module";
import { ValgDKSearchComponent } from "./valgdk-search.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ValgSharedDirectivesModule } from "@valg-shared/directives/valg-shared-directives.module";

@NgModule({
  declarations: [ ValgDKSearchComponent ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ValgInputModule,
    TooltipModule,
    FormsModule,
    ReactiveFormsModule,
    ValgSharedDirectivesModule
  ],
  exports: [ ValgDKSearchComponent, ValgInputModule ],
})
export class ValgDKSearchModule {}
